import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class ResourceBudgetAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // clinical api endpoints
  providers = ApiRoutes.resourceBudget.Providers
  clinicalCreate = ApiRoutes.resourceBudget.clinicalCreate
  clinical = ApiRoutes.resourceBudget.clinical
  clinicalUpdate = ApiRoutes.resourceBudget.clinicalUpdate
  clinicalCopyOptions = ApiRoutes.resourceBudget.clinicalCopyOptions

  // Non clinical api endpoints
  nonClinical = ApiRoutes.resourceBudget.nonClinical
  nonClinicalUpdate = ApiRoutes.resourceBudget.nonClinicalUpdate
  nonClinicalRoles = ApiRoutes.resourceBudget.nonClinicalRoles
  nonClinicalCreate = ApiRoutes.resourceBudget.nonClinicalCreate
  nonClinicalCopyOptions = ApiRoutes.resourceBudget.nonClinicalCopyOptions

  // Forecast
  forecastClinicalCreate = ApiRoutes.resourceBudget.clinicalForecastCreate
  forecastNonClinicalCreate = ApiRoutes.resourceBudget.nonClinicalForecastCreate
  copyToForecastEndpoint = ApiRoutes.resourceBudget.copyToForecast

  //Budget publish endpoint
  publishBudget = ApiRoutes.resourceBudget.publishBudget
  clinicalDelete = ApiRoutes.resourceBudget.clinicalDelete
  nonClinicalDelete = ApiRoutes.resourceBudget.nonClinicalDelete
  copyOptions = ApiRoutes.resourceBudget.setCopyToOptions
  availabelBudgetYears = ApiRoutes.resourceBudget.availabelBudgetYears
  syncBudget = ApiRoutes.resourceBudget.syncBudget

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getProviders = (params: any) => {
    const { token, practiceSk, providerType } = params
    return this.instance({
      method: this.providers.Method,
      url: this.providers.EndPoint(practiceSk, providerType),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getClinicalData = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.clinical.Method,
      url: this.clinical.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  createClinicalProvider = (params: any) => {
    const { token, payload, published } = params
    let args = {
      method: this.clinicalCreate.Method,
      url: this.clinicalCreate.EndPoint,
    }
    if (!published) {
      args = {
        method: this.forecastClinicalCreate.Method,
        url: this.forecastClinicalCreate.EndPoint,
      }
    }
    return this.instance({
      ...args,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }
  updateClinicalData = (params: any) => {
    const { token, payload, args } = params
    return this.instance({
      method: this.clinicalUpdate.Method,
      url: this.clinicalUpdate.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }

  // New method for bulk clinical updates with array payload
  bulkUpdateClinicalData = (params: any) => {
    const { token, payload, args } = params
    return this.instance({
      method: this.clinicalUpdate.Method,
      url: this.clinicalUpdate.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload, // This will be an array of objects
    })
  }
  deleteClinicalData = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.clinicalDelete.Method,
      url: this.clinicalDelete.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getNonClinicalData = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.nonClinical.Method,
      url: this.nonClinical.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  updateNonClinicalData = (params: any) => {
    const { token, payload, args } = params
    return this.instance({
      method: this.nonClinicalUpdate.Method,
      url: this.nonClinicalUpdate.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }

  // New method for bulk non-clinical updates with array payload
  bulkUpdateNonClinicalData = (params: any) => {
    const { token, payload, args } = params
    return this.instance({
      method: this.nonClinicalUpdate.Method,
      url: this.nonClinicalUpdate.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload, // This will be an array of objects
    })
  }
  getNonClinicalRoles = (token: string) => {
    return this.instance({
      method: this.nonClinicalRoles.Method,
      url: this.nonClinicalRoles.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  deleteNonClinicalData = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.nonClinicalDelete.Method,
      url: this.nonClinicalDelete.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  createNonClinicalProvider = (params: any) => {
    const { token, payload, published } = params
    let args = {
      method: this.nonClinicalCreate.Method,
      url: this.nonClinicalCreate.EndPoint,
    }
    if (!published) {
      args = {
        method: this.forecastNonClinicalCreate.Method,
        url: this.forecastNonClinicalCreate.EndPoint,
      }
    }
    return this.instance({
      ...args,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }
  getClinicalCopyOptions = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.clinicalCopyOptions.Method,
      url: this.clinicalCopyOptions.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getNonClinicalCopyOptions = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.nonClinicalCopyOptions.Method,
      url: this.nonClinicalCopyOptions.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  postPublishBudget = (params: any) => {
    const { token, args } = params
    return this.instance({
      method: this.publishBudget.Method,
      url: this.publishBudget.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  setCopyOptions = (params: any) => {
    const { token, payload, args } = params
    return this.instance({
      method: this.copyOptions.Method,
      url: this.copyOptions.EndPoint(args),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    })
  }
  getAvailableBudgetYears = (params: any) => {
    const { token, practiceSk } = params
    return this.instance({
      method: this.availabelBudgetYears.Method,
      url: this.availabelBudgetYears.EndPoint(practiceSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  syncBudgetToPnl = (params: any) => {
    const { token, args } = params
    const { practiceSk, year } = args
    return this.instance({
      method: this.syncBudget.Method,
      url: this.syncBudget.EndPoint(practiceSk, year),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  copyToForecast = (params: any) => {
    const { token, payload } = params
    const { year, practice_sk } = payload
    return this.instance({
      method: this.copyToForecastEndpoint.Method,
      url: this.copyToForecastEndpoint.EndPoint({ year, practice_sk }),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
